import { FC } from 'react';

import {
	AwardRibbonOutline,
	CelebrationStreakOutline,
	ChartBarOutline,
	ChatAlt2Outline,
	ChatAltOutline,
	HistoryOutline,
	IconProps,
	ShoppingCartOutline,
	TargetOutline,
	UsersOutline,
} from '@bonusly/design-system';

export type SidebarItemId = 'oneOnOnes' | 'goals' | 'recaps' | 'team' | 'rewards' | 'incentives' | 'leaderboard' | 'celebrations' | 'advice';

export type SidebarItemConfig = {
	id: SidebarItemId;
	translationKey: string;
	icon: FC<IconProps>;
};

export const SIDEBAR_ITEMS: SidebarItemConfig[] = [
	{
		id: 'oneOnOnes',
		translationKey: 'links.oneOnOnes',
		icon: ChatAlt2Outline,
	},
	{
		id: 'goals',
		translationKey: 'links.goals',
		icon: TargetOutline,
	},
	{
		id: 'recaps',
		translationKey: 'links.recaps',
		icon: HistoryOutline,
	},
	{
		id: 'team',
		translationKey: 'links.team',
		icon: UsersOutline,
	},
	{
		id: 'rewards',
		translationKey: 'links.rewards',
		icon: ShoppingCartOutline,
	},
	{
		id: 'incentives',
		translationKey: 'links.incentives',
		icon: AwardRibbonOutline,
	},
	{
		id: 'leaderboard',
		translationKey: 'links.leaderboard',
		icon: ChartBarOutline,
	},
	{
		id: 'celebrations',
		translationKey: 'links.celebrations',
		icon: CelebrationStreakOutline,
	},
	{
		id: 'advice',
		translationKey: 'links.feedback',
		icon: ChatAltOutline,
	},
];

export const DEFAULT_HIDDEN_ITEMS: ReadonlySet<SidebarItemId> = new Set<SidebarItemId>();
